import * as yup from "yup";

export const ProvinceSetupValidationSchema = yup.object({
  name: yup
    .string()
    .required("Province Name is required")
    .min(1, "Minimum length 1 characters")
    .max(60, "Maximum length 60 characters"),
  shortCode: yup
    .string()
    .required("Province Short Code is required")
    .min(1, "Minimum length 1 characters")
    .max(3, "Maximum length 3 characters"),
  country: yup
    .string()
    .required("Country is required"),
})